export function BarChartIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.61111 9.66667V11.1111M7.5 6.77778V11.1111M10.3889 3.88889V11.1111M4.46667 14H10.5333C11.7468 14 12.3535 14 12.817 13.7638C13.2247 13.5561 13.5561 13.2247 13.7638 12.817C14 12.3535 14 11.7468 14 10.5333V4.46667C14 3.25322 14 2.6465 13.7638 2.18302C13.5561 1.77534 13.2247 1.44388 12.817 1.23615C12.3535 1 11.7468 1 10.5333 1H4.46667C3.25322 1 2.6465 1 2.18302 1.23615C1.77534 1.44388 1.44388 1.77534 1.23615 2.18302C1 2.6465 1 3.25322 1 4.46667V10.5333C1 11.7468 1 12.3535 1.23615 12.817C1.44388 13.2247 1.77534 13.5561 2.18302 13.7638C2.6465 14 3.25322 14 4.46667 14Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
